<template>
  <!-- « CONFIGURATION » — the org's setup gaps, one click away from every page.
       It exists only while a check fails: a button that is always there is ink,
       and a well-run shop never sees it. Amber, never red — nothing on the list
       is an emergency. The count is failing CHECKS, not records (« Équipe sans
       membre » for two crews is one thing to fix); the dialog shows the done
       ones too. -->
  <Button
    v-if="failing.length"
    variant="outline"
    class="h-9 gap-2 font-semibold"
    data-testid="setup-check-button"
    @click="open = true"
  >
    <ListChecks class="h-4 w-4" />
    {{ t('setupCheck.button') }}
    <span
      class="inline-grid h-5 min-w-5 place-items-center rounded-full bg-tone-amber-soft px-1.5 text-xs font-bold tabular-nums text-tone-amber"
      data-testid="setup-check-count"
    >{{ failing.length }}</span>
  </Button>
  <SetupCheckDialog :open="open" :checks="checks" @close="open = false" />
</template>

<script setup lang="ts">
import { computed, ref, watch, watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'
import { ListChecks } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import SetupCheckDialog from '@/components/layout/SetupCheckDialog.vue'
import { useSetupCheck } from '@/composables/useSetupCheck'
import { failingChecks } from '@/lib/setupCheck'
import { useOrganizationStore } from '@/stores/organization'

const { t } = useI18n()
const orgStore = useOrganizationStore()
const { meta, refetch, ensure } = useSetupCheck()

const open = ref(false)
const checks = computed(() => meta.value?.checks ?? [])
const failing = computed(() => failingChecks(checks.value))

watchEffect(() => {
  const orgId = orgStore.currentOrganization?.id
  if (orgId) ensure(orgId)
})

// Opening re-reads: other people's writes (a technician's phone registering)
// never announce themselves to this tab.
watch(open, isOpen => { if (isOpen) void refetch() })
</script>
